import './promo-upload.less';
import PropTypes from 'prop-types';
import React from 'react';

const PromoUpload = props => (
	<div className="form-element-upload__promo">
		<div className="form-element-upload__control">
			<h3>{props.title}</h3>
			<p>{props.accent}</p>
		</div>
		<input
			type="file"
			className="control"
			multiple={true}
			accept=".png, .jpeg, .jpg, .webp, .pdf, .mov, .jfif, .heic, .bmp, .docx"
			onChange={e => props.upload(e.target.files)}/>
	</div>
);

PromoUpload.propTypes = {
	title: PropTypes.string,
	accent: PropTypes.string,
	input: PropTypes.object,
	upload: PropTypes.func
};

export default PromoUpload;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form-elements/promo-upload.js